import toast from "react-hot-toast";
import { config } from "../../Utils/helpers";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewCabRequestList = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CAB_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/cab-setting/list`,
        requestData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CAB_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_CAB_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_CAB_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewCabRequest = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CAB_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/cab-setting/view/${requestData}`,
        requestData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CAB_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_CAB_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_CAB_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addCabCategory = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_CAB_CATEGORY_REQUEST" });
      const configData = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/cab-setting/add`,
        requestData,
        configData
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_CAB_CATEGORY_SUCCESS", payload: data });
        toast.success("Added Succesfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_CAB_CATEGORY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_CAB_CATEGORY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const editCabCategory = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_CAB_CATEGORY_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/cab-setting/update`,
        requestData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_CAB_CATEGORY_SUCCESS", payload: data });
        toast.success("Edit Succesfully!!");
        return data;
      } else {
        dispatch({ type: "EDIT_CAB_CATEGORY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "EDIT_CAB_CATEGORY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
// List Cab Service Providers
export const listCabService = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CAB_SERVICE_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/cab-service-provider/list`,
        requestData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CAB_SERVICE_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_CAB_SERVICE_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_CAB_SERVICE_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// Add Cab Service Provider
export const addCabService = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_CAB_SERVICE_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/cab-service-provider/add`,
        requestData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_CAB_SERVICE_SUCCESS", payload: data });
        toast.success("Service Provider Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_CAB_SERVICE_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_CAB_SERVICE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
